import Flickity from 'flickity';

const announcements = {};

const announcementInit = (carousel, index) => {
  if (carousel.children.length < 2) {
    // Don't init pointless carousels with 1 or no slides
    return;
  }

  const elements = carousel.querySelectorAll('#country-picker');
  elements.forEach((element) => {
    element.remove();
  });
  const id = carousel.parentElement.getAttribute('id');
  announcements[id] = new Flickity(carousel, {
    initialIndex: index || 0,
    prevNextButtons: carousel.dataset.prevNextButtons === 'true',
    autoPlay: carousel.dataset.autoPlay,
    dragThreshold: window.theme.flickity.dragThreshold,
    pageDots: false,
    draggable: true,
    wrapAround: true,
    pauseAutoPlayOnHover: true,
    setGallerySize: false,
  });
};

export { announcements, announcementInit };
